import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/auth';

export const PermissionRoute = ({ permission }) => {
  const { t } = useTranslation();
  const { can } = useAuth();

  if (!can(permission)) {
    return (
      <div className="permission-denied">
        <h2>{t('common.accessDenied')}</h2>
        <p>{t('common.noPermission')}</p>
      </div>
    );
  }

  return <Outlet />;
};
